import RequestPageTwo from "./RequestPageTwo";

const IndividualPooja = () => {
    return (
        <RequestPageTwo title="Individual Pooja Request form"
            fetchUrl="/get-individual-pooja-requests"
            editEndpoint="update-individual-pooja-requests"
            deleteEndpoint="individual-pooja-requests"
            statusEndpoint="update-individual-pooja-requests" />
    );
}

export default IndividualPooja;
